module.exports = __webpack_public_path__ + "static/media/banner_2.2d87ee2b.png";